import React, {Component} from 'react';
import {Link} from 'react-router';

import Card from 'js/components/card';
import Footer from 'js/components/footer';

const cardGroups = [
    [
        {
            image: require('images/icons/laptop.png'),
            header: 'What is Social Native?',
            body: <p>Social Native connects brands with epic content creators, like you, to create authentic and compelling branded content. Join the platform to collaborate on fun campaigns with the brands you love. Choose the campaigns that work for you, create unique and inspiring content, and earn rewards!</p>
        },
        {
            image: require('images/icons/envelope.png'),
            header: "Why did Social Native send me a campaign invite?",
            body: <p>You received a campaign invite from us because we spotted your social media profile and think the content you create is awesome. We love your aesthetic, and think you'd be a great fit for one of our upcoming campaigns!</p>
        }
    ],
    [
        {
            image: require('images/icons/users.png'),
            header: 'How can I join Social Native?',
            body: <p>If you've received a campaign invite, you can join Social Native through your unique invite link. If you haven't received a campaign invite, but would like to join, you can <a href="http://my.socialnative.com/creator/sign_up?utm_source=snwebsitefaqs">sign up here</a>. Make sure you complete your Social Native profile after signing up so we can match you with campaigns!</p>
        },
        {
            image: require('images/icons/key.png'),
            header: "Why do I have to verify using a social media account?",
            body: <p>Verifying your social account lets us know that you own the account we invited to a campaign, and enables the analytics that you'll see in your Social Native dashboard. Don't worry - we'll never comment, like, or post on your behalf, and we don't store your password.</p>
        }
    ],
    [
        {
            image: require('images/icons/blueprints.png'),
            header: 'Is Social Native right for me?',
            body: <p>If you have a great eye and a creative aesthetic, we probably have a campaign for you! There are a few things we check for before you're eligible to participate:<br/>- Brand safety: no swearing, sexual imagery, drug use, or other illegal/inappropriate activity. <br/>- Authenticity: no non-genuine followers or spammy activity. <br/>- Content quality: well-lit, high-resolution photos and videos. <br/><br/>Here's your chance to collaborate with the brands you love - so make sure you put your best foot forward!</p>
        },
        {
            image: require('images/icons/post.png'),
            header: 'How do Social Native Campaigns work?',
            body: <p>When we match you with a campaign, we'll send you an invite. Check out the guidelines to learn the type of content the brand is looking for, and accept if you're interested in participating. Then, we'll work to secure you a spot (campaigns fill up quickly, so make sure you keep your eye out for invites).<br/><br/>If we find you a spot in the campaign, you'll create content that meets the guidelines, post during the posting window, and submit via your Social Native dashboard. Once we confirm that your post meets the guidelines, you'll be eligible for rewards. It's as easy as that!</p>
        }
    ],
    [
        {
            image: require('images/icons/credit_card.png'),
            header: 'Will I be paid for participating in this campaign?',
            body: <p>Compensation amounts vary by campaign; some campaigns are paid, others earn you free products. Plus, there's the chance that the brand will feature your content - brands love showing off the awesome content from their Social Native campaigns! Check the "What's In It For Me?" section of your campaign invite for the details.</p>
        },
        {
            image: require('images/icons/wallet.png'),
            header: 'How does payment work?',
            body: <p>Each campaign offers a specific, non-negotiable payment amount. When you accept a campaign, you're agreeing to the terms and conditions and confirming that your post must meet the campaign guidelines before payment will be made. If your content meets the campaign guidelines, we'll process your payment within 14 days of approval. All payments are made via PayPal</p>
        }
    ],
    [
        {
            image: require('images/icons/tower.png'),
            header: 'How do I find more campaigns? ',
            body: <p>Once you're signed up, we'll reach out with campaign invites that you're a match for! You can also request invitations to open campaigns shown on your dashboard.</p>
        },
        {
            image: require('images/icons/presentation.png'),
            header: 'What are Social Native\'s Terms of Service?',
            body: <p>Our Terms of Service can be found <a
                href="http://my.socialnative.com/creator/terms">here</a>.</p>
        }
    ],
    [
        {
            image: require('images/icons/bar_chart.png'),
            header: 'I have a brand - how do I start a Social Native campaign?',
            body: <p>Awesome! Go <a href="https://my.socialnative.com/brand/signup">here</a> to request access.</p>
        },
        {
            image: require('images/icons/camera.png'),
            header: 'Who are you guys?',
            body: <p><a href="http://www.instagram.com/social_native">Check out our Instagram</a> to meet the Social Native team!</p>
        }
    ],
    [
        {
            image: require('images/icons/megaphone.png'),
            header: 'More Questions?',
            body: <p>Please email <a href="mailto:info@socialnative.com?subject=FAQS%20More%20Questions">info@socialnative.com</a>.</p>
        }
    ]
];

export default class Faq extends Component {
    constructor(){
        super();
        this.displayFaqRows = this.displayFaqRows.bind(this);
    }

    displayFaqRows() {
        const rows = cardGroups.map((cg, i) => {
            if (cg.length === 2) {
                return(
                    <div className="row" key={i}>
                        <div className="gr-6@md">
                            <Card {...cg[0]} />
                        </div>
                        <div className="gr-6@md">
                            <Card {...cg[1]} />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="row" key={i}>
                        <div className="gr-6@md">
                            <Card {...cg[0]} />
                        </div>
                    </div>
                );
            }
        });

        return rows;
    }

    render() {
        const faqs = this.displayFaqRows();

        return (
            <div id="faq">
                <header className="header-blue">
                    <div id="sn-logo" className="hide show@sm">
                        <Link to="/">

                        </Link>
                    </div>
                    <div id="sn-logo-mobile" className="hide@sm">
                        <Link to="/">

                        </Link>
                    </div>

                    <div className="hide show@sm">
                        <Link to="/content_creator">CONTENT CREATORS</Link>
                        <Link className="active" to="/faq">FAQ</Link>
                    </div>
                    <div className="header-title">
                        <h1>Have Questions?</h1>
                        <h1> We have answers!</h1>
                    </div>
                </header>
                <main className="container">
                    {faqs}
                </main>
                <Footer >
                    <a className="get-started-footer" href="http://my.socialnative.com/creator/sign_up?utm_source=snwebsitefaqs">Get Started!</a>
                </Footer>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web/js/pages/faq.js